var _style, _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClrHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#172D6F;}\n\t.st1{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#172E70;}\n\t.st2{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#162F70;}\n\t.st3{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#152F70;}\n\t.st4{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#153071;}\n\t.st5{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#143171;}\n\t.st6{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#133272;}\n\t.st7{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#133372;}\n\t.st8{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#123372;}\n\t.st9{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#113473;}\n\t.st10{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#103573;}\n\t.st11{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0F3673;}\n\t.st12{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0E3674;}\n\t.st13{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0D3774;}\n\t.st14{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0D3874;}\n\t.st15{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0C3875;}\n\t.st16{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0B3975;}\n\t.st17{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0A3975;}\n\t.st18{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#093A75;}\n\t.st19{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#093A76;}\n\t.st20{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#083A76;}\n\t.st21{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#073B76;}\n\t.st22{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#063B76;}\n\t.st23{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#063C77;}\n\t.st24{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#053C77;}\n\t.st25{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#043D77;}\n\t.st26{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#033D77;}\n\t.st27{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#023E78;}\n\t.st28{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#013E78;}\n\t.st29{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003F78;}\n\t.st30{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003F79;}\n\t.st31{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#004079;}\n\t.st32{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003F77;}\n\t.st33{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003E77;}\n\t.st34{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003E76;}\n\t.st35{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003D75;}\n\t.st36{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003C74;}\n\t.st37{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003C73;}\n\t.st38{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003B73;}\n\t.st39{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003B72;}\n\t.st40{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003A72;}\n\t.st41{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003A71;}\n\t.st42{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003970;}\n\t.st43{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003870;}\n\t.st44{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#00386F;}\n\t.st45{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#00376E;}\n\t.st46{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#00366D;}\n\t.st47{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#00366C;}\n\t.st48{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#00356C;}\n\t.st49{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#00356B;}\n\t.st50{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#00346A;}\n\t.st51{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003369;}\n\t.st52{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003268;}\n\t.st53{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003167;}\n\t.st54{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003066;}\n\t.st55{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003065;}\n\t.st56{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#002F65;}\n\t.st57{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#003166;}\n\t.st58{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#013167;}\n\t.st59{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#013268;}\n\t.st60{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#023268;}\n\t.st61{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#033369;}\n\t.st62{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#04346A;}\n\t.st63{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#05346A;}\n\t.st64{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#05356B;}\n\t.st65{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#06356C;}\n\t.st66{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#07356C;}\n\t.st67{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#07366D;}\n\t.st68{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#08366D;}\n\t.st69{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#09376E;}\n\t.st70{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0A376F;}\n\t.st71{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0B386F;}\n\t.st72{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0B3870;}\n\t.st73{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0C3970;}\n\t.st74{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0D3971;}\n\t.st75{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0D3A72;}\n\t.st76{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0E3A72;}\n\t.st77{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#0F3B73;}\n\t.st78{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#103B73;}\n\t.st79{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#103C74;}\n\t.st80{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#113C74;}\n\t.st81{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#123D75;}\n\t.st82{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#123D76;}\n\t.st83{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#133E76;}\n\t.st84{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#143E77;}\n\t.st85{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#143F77;}\n\t.st86{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#153F78;}\n\t.st87{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#164079;}\n\t.st88{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#17417A;}\n\t.st89{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#18427B;}\n\t.st90{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#19427C;}\n\t.st91{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#19437C;}\n\t.st92{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1A437D;}\n\t.st93{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1A447D;}\n\t.st94{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1B447E;}\n\t.st95{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1C457F;}\n\t.st96{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1D4680;}\n\t.st97{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1D4681;}\n\t.st98{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1E4781;}\n\t.st99{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1E4782;}\n\t.st100{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#1F4882;}\n\t.st101{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#204883;}\n\t.st102{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#204984;}\n\t.st103{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#214984;}\n\t.st104{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#214A85;}\n\t.st105{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#224A85;}\n\t.st106{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#224B86;}\n\t.st107{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#234B87;}\n\t.st108{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#234C87;}\n\t.st109{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#244C88;}\n\t.st110{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#244D88;}\n\t.st111{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#254D89;}\n\t.st112{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#254D8A;}\n\t.st113{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#264E8A;}\n\t.st114{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#264E8B;}\n\t.st115{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#274F8B;}\n\t.st116{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#284F8C;}\n\t.st117{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#28508C;}\n\t.st118{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#29508D;}\n\t.st119{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#29518E;}\n\t.st120{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2A518E;}\n\t.st121{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2A528F;}\n\t.st122{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2B528F;}\n\t.st123{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2B5390;}\n\t.st124{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2C5391;}\n\t.st125{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2C5491;}\n\t.st126{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2D5492;}\n\t.st127{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2D5592;}\n\t.st128{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2E5593;}\n\t.st129{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2E5694;}\n\t.st130{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2F5694;}\n\t.st131{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#2F5795;}\n\t.st132{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#305795;}\n\t.st133{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#305896;}\n\t.st134{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#315897;}\n\t.st135{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#315997;}\n\t.st136{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#325998;}\n\t.st137{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#325A98;}\n\t.st138{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#335A99;}\n\t.st139{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#335A9A;}\n\t.st140{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#345B9A;}\n\t.st141{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#345B9B;}\n\t.st142{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#355C9B;}\n\t.st143{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#355C9C;}\n\t.st144{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#365D9D;}\n\t.st145{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#375E9E;}\n\t.st146{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#385F9F;}\n\t.st147{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#385FA0;}\n\t.st148{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3960A0;}\n\t.st149{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3960A1;}\n\t.st150{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3A61A1;}\n\t.st151{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3A61A2;}\n\t.st152{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3B62A3;}\n\t.st153{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3C63A4;}\n\t.st154{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3D64A5;}\n\t.st155{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3E64A6;}\n\t.st156{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3E65A6;}\n\t.st157{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3F65A7;}\n\t.st158{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#3F66A8;}\n\t.st159{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4066A8;}\n\t.st160{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4067A9;}\n\t.st161{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4167AA;}\n\t.st162{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4168AA;}\n\t.st163{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4269AB;}\n\t.st164{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4369AC;}\n\t.st165{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#446AAE;}\n\t.st166{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#456BAD;}\n\t.st167{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#466BAC;}\n\t.st168{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#476BAC;}\n\t.st169{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#476BAB;}\n\t.st170{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#486CAB;}\n\t.st171{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#496CAB;}\n\t.st172{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4A6CAA;}\n\t.st173{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4B6DAA;}\n\t.st174{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4C6DAA;}\n\t.st175{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4D6DA9;}\n\t.st176{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4E6EA9;}\n\t.st177{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#4F6EA8;}\n\t.st178{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#506EA8;}\n\t.st179{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#516FA8;}\n\t.st180{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#526FA8;}\n\t.st181{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#526FA7;}\n\t.st182{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5370A7;}\n\t.st183{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5470A7;}\n\t.st184{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5570A7;}\n\t.st185{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5571A6;}\n\t.st186{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5671A6;}\n\t.st187{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5771A6;}\n\t.st188{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5871A5;}\n\t.st189{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5972A5;}\n\t.st190{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5A72A4;}\n\t.st191{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5B73A4;}\n\t.st192{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5C73A4;}\n\t.st193{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5D74A3;}\n\t.st194{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5E74A3;}\n\t.st195{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#5F74A3;}\n\t.st196{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6075A2;}\n\t.st197{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6175A2;}\n\t.st198{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6275A2;}\n\t.st199{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6276A1;}\n\t.st200{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6376A1;}\n\t.st201{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6476A1;}\n\t.st202{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6477A1;}\n\t.st203{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6577A0;}\n\t.st204{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6677A0;}\n\t.st205{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6778A0;}\n\t.st206{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#67789F;}\n\t.st207{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#68789F;}\n\t.st208{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#69799F;}\n\t.st209{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6A799E;}\n\t.st210{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6B7A9E;}\n\t.st211{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6C7A9E;}\n\t.st212{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6D7B9D;}\n\t.st213{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6E7B9D;}\n\t.st214{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#6F7C9C;}\n\t.st215{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#707C9C;}\n\t.st216{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#717D9B;}\n\t.st217{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#727D9B;}\n\t.st218{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#737E9B;}\n\t.st219{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#747E9A;}\n\t.st220{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#757F9A;}\n\t.st221{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#767F99;}\n\t.st222{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#778099;}\n\t.st223{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#788099;}\n\t.st224{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#788098;}\n\t.st225{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#798198;}\n\t.st226{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7A8198;}\n\t.st227{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7A8197;}\n\t.st228{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7B8297;}\n\t.st229{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7C8297;}\n\t.st230{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7C8296;}\n\t.st231{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7D8396;}\n\t.st232{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7E8396;}\n\t.st233{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7E8395;}\n\t.st234{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#7F8495;}\n\t.st235{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#808495;}\n\t.st236{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#808594;}\n\t.st237{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#818594;}\n\t.st238{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#828693;}\n\t.st239{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#838693;}\n\t.st240{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#848792;}\n\t.st241{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#858792;}\n\t.st242{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#868891;}\n\t.st243{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#878891;}\n\t.st244{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#878991;}\n\t.st245{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#888990;}\n\t.st246{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#898990;}\n\t.st247{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#898A90;}\n\t.st248{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#8A8A8F;}\n\t.st249{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#8B8A8F;}\n\t.st250{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#8B8B8F;}\n\t.st251{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#8C8B8E;}\n\t.st252{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#8D8C8E;}\n\t.st253{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#8E8C8D;}\n\t.st254{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#8E8D8D;}\n\t.st255{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#8F8D8D;}\n\t.st256{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#908D8C;}\n\t.st257{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#908E8C;}\n\t.st258{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#918E8C;}\n\t.st259{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#928E8B;}\n\t.st260{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#928F8B;}\n\t.st261{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#938F8B;}\n\t.st262{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#94908A;}\n\t.st263{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#95908A;}\n\t.st264{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#969189;}\n\t.st265{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#979289;}\n\t.st266{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#989288;}\n\t.st267{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#999388;}\n\t.st268{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9A9387;}\n\t.st269{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9A9487;}\n\t.st270{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9B9486;}\n\t.st271{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9C9586;}\n\t.st272{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9D9585;}\n\t.st273{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9D9685;}\n\t.st274{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9E9685;}\n\t.st275{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9F9684;}\n\t.st276{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#9F9784;}\n\t.st277{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A09784;}\n\t.st278{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A19883;}\n\t.st279{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A29883;}\n\t.st280{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A39982;}\n\t.st281{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A49A82;}\n\t.st282{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A59A81;}\n\t.st283{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A69A81;}\n\t.st284{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A69B81;}\n\t.st285{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A79B80;}\n\t.st286{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A89C80;}\n\t.st287{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A89C7F;}\n\t.st288{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#A99D7F;}\n\t.st289{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#AA9D7F;}\n\t.st290{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#AA9D7E;}\n\t.st291{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#AB9E7E;}\n\t.st292{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#AC9E7E;}\n\t.st293{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#AC9F7D;}\n\t.st294{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#AD9F7D;}\n\t.st295{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#AEA07C;}\n\t.st296{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#AFA07C;}\n\t.st297{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B0A17B;}\n\t.st298{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B1A17B;}\n\t.st299{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B1A27A;}\n\t.st300{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B2A27A;}\n\t.st301{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B3A37A;}\n\t.st302{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B3A379;}\n\t.st303{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B4A479;}\n\t.st304{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B5A478;}\n\t.st305{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B6A578;}\n\t.st306{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B7A577;}\n\t.st307{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B8A677;}\n\t.st308{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B8A676;}\n\t.st309{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#B9A776;}\n\t.st310{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#BAA775;}\n\t.st311{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#BAA875;}\n\t.st312{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#BBA875;}\n\t.st313{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#BCA974;}\n\t.st314{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#BDA973;}\n\t.st315{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#BEAA73;}\n\t.st316{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#BEAA72;}\n\t.st317{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#BFAB72;}\n\t.st318{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C0AB71;}\n\t.st319{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C1AC71;}\n\t.st320{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C1AC70;}\n\t.st321{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C2AD70;}\n\t.st322{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C3AD6F;}\n\t.st323{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C3AE6F;}\n\t.st324{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C4AE6E;}\n\t.st325{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C5AE6E;}\n\t.st326{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C6AF6D;}\n\t.st327{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C7B06C;}\n\t.st328{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C8B06C;}\n\t.st329{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C8B16B;}\n\t.st330{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#C9B16B;}\n\t.st331{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#CAB26A;}\n\t.st332{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#CBB369;}\n\t.st333{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#CCB368;}\n\t.st334{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#CCB468;}\n\t.st335{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#CDB467;}\n\t.st336{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#CEB467;}\n\t.st337{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#CFB566;}\n\t.st338{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D0B665;}\n\t.st339{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D1B665;}\n\t.st340{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D1B764;}\n\t.st341{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D2B763;}\n\t.st342{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D3B863;}\n\t.st343{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D3B862;}\n\t.st344{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D4B962;}\n\t.st345{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D5B961;}\n\t.st346{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D6BA60;}\n\t.st347{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D7BB5F;}\n\t.st348{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D8BB5F;}\n\t.st349{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D8BC5E;}\n\t.st350{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#D9BC5E;}\n\t.st351{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#DABD5D;}\n\t.st352{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#DBBD5C;}\n\t.st353{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#DBBE5C;}\n\t.st354{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#DCBE5B;}\n\t.st355{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#DDBF5B;}\n\t.st356{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#DDBF5A;}\n\t.st357{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#DEC059;}\n\t.st358{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#DFC059;}\n\t.st359{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E0C158;}\n\t.st360{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E1C257;}\n\t.st361{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E2C257;}\n\t.st362{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E3C356;}\n\t.st363{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E3C355;}\n\t.st364{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E4C455;}\n\t.st365{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E5C454;}\n\t.st366{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E5C554;}\n\t.st367{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E6C553;}\n\t.st368{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E7C653;}\n\t.st369{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E7C652;}\n\t.st370{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E8C752;}\n\t.st371{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#E9C751;}\n\t.st372{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#EAC850;}\n\t.st373{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#EBC94F;}\n\t.st374{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#ECC94F;}\n\t.st375{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#ECCA4E;}\n\t.st376{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#EDCA4D;}\n\t.st377{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#EECB4D;}\n\t.st378{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#EFCB4C;}\n\t.st379{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#EFCC4C;}\n\t.st380{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F0CC4B;}\n\t.st381{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F1CD4B;}\n\t.st382{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F2CD4A;}\n\t.st383{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F2CE4A;}\n\t.st384{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F3CF49;}\n\t.st385{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F4CF49;}\n\t.st386{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F5D048;}\n\t.st387{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F6D148;}\n\t.st388{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F7D147;}\n\t.st389{clip-path:url(#SVGID_00000042734755788107048420000007526155997217340343_);fill:#F9D247;}\n\t.st390{fill:#0F0D09;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M11.9,35.03c0.02,7.47,6.06,13.51,13.52,13.54c7.46-0.03,13.5-6.07,13.51-13.54 c0.02-9.44-12.34-22.48-13.51-34.78C24.24,12.54,11.88,25.59,11.9,35.03z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082340667182438182840000010575149260677916811_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.93,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#172D6F"
    },
    width: 0.02,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.93,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#172D6F"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.92,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#172E70"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.91,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#162F70"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.91,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#152F70"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#153071"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#143171"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#133272"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.88,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#133372"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.87,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#123372"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.87,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#113473"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.86,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#103573"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.86,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#103573"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.85,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0F3673"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.84,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0E3674"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.84,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0D3774"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.83,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0D3874"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.82,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0C3875"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.82,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0B3975"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.81,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0A3975"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#093A75"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.8,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#093A76"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#083A76"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#073B76"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.78,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#063B76"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.77,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#063C77"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.77,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#053C77"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.76,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#053C77"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.75,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#043D77"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.75,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#033D77"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.74,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#033D77"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.73,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#023E78"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.73,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#023E78"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.72,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#013E78"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.71,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#013E78"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.71,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003F78"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.7,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003F78"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.7,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003F78"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.69,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003F79"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.68,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003F79"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.68,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.67,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.66,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.65,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.63,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.63,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.62,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.61,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.61,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.6,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.45,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.31,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#004079"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.17,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003F78"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.03,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003F77"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003E77"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003E76"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.61,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003D75"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.47,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003D75"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.33,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003C74"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003C73"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003B73"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003B72"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.76,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003A72"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.62,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003A71"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.48,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003970"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.34,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003870"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.2,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00386F"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.06,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00376E"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.92,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00376E"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.78,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00366D"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00366C"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00356C"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.36,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00356B"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.21,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00346A"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.07,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#00346A"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.93,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003369"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003268"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.65,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003268"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.51,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003167"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.37,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003167"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.23,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003066"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003065"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.95,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#002F65"
    },
    width: 0.14,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#002F65"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.85,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003065"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003066"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.75,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#003166"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#013167"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.65,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#013268"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#023268"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.55,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#033369"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#033369"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.45,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#04346A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#05346A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.35,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#05356B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#06356C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.25,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#07356C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.2,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#07366D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.15,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#08366D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#09376E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.05,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0A376F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0B386F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.95,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0B3870"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0C3970"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.85,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0D3971"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0D3A72"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.75,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0E3A72"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#0F3B73"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#103B73"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#103C74"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.54,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#113C74"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.49,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#123D75"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.44,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#123D76"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.39,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#133E76"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.34,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#143E77"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.29,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#143F77"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.24,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#153F78"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#164079"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.14,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#164079"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#17417A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#17417A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.99,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#18427B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.94,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#19427C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#19437C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.84,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1A437D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1A447D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.74,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1B447E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.69,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1C457F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1C457F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1D4680"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.54,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1D4681"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.49,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1E4781"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.44,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1E4782"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.39,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#1F4882"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#204883"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.29,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#204984"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.24,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#214984"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#214A85"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.14,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#224A85"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#224B86"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#234B87"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.99,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#234C87"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.94,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#244C88"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#244D88"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.84,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#254D89"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#254D8A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.74,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#264E8A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.69,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#264E8B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#274F8B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#284F8C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.54,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#28508C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.49,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#29508D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.44,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#29518E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.39,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2A518E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.34,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2A528F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.29,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2B528F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.24,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2B5390"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2C5391"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.14,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2C5491"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2D5492"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2D5592"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.99,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2E5593"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.94,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2E5694"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2F5694"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.84,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#2F5795"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#305795"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.74,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#305896"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.69,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#315897"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#315997"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#325998"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.54,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#325A98"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.49,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#335A99"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.44,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#335A9A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.39,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#345B9A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.34,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#345B9B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.29,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#355C9B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.24,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#355C9C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#365D9D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.14,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#365D9D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#375E9E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#375E9E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.99,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#385F9F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.94,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#385FA0"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3960A0"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.84,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3960A1"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3A61A1"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.74,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3A61A2"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.69,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3B62A3"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3B62A3"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3C63A4"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.54,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3C63A4"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.49,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3D64A5"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.44,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3E64A6"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.39,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3E65A6"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.34,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3F65A7"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.29,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#3F66A8"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.24,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4066A8"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4067A9"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.14,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4167AA"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4168AA"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4269AB"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.99,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4369AC"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.94,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#446AAE"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#446AAE"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.84,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#456BAD"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#466BAC"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.75,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#476BAC"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.71,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#476BAB"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.66,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#486CAB"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.62,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#496CAB"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.57,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4A6CAA"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.53,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4B6DAA"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.48,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4C6DAA"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.44,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4D6DA9"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.39,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4E6EA9"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.35,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4E6EA9"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.3,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#4F6EA8"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.26,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#506EA8"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.21,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#516FA8"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.17,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#526FA8"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.12,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#526FA7"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.07,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5370A7"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.03,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5470A7"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.98,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5570A7"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.94,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5571A6"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.89,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5671A6"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5771A6"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5871A5"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.76,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5972A5"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.71,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5972A5"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.67,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5A72A4"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.62,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5B73A4"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.58,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5C73A4"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.53,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5C73A4"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.49,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5D74A3"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.44,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5E74A3"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.39,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5F74A3"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.35,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#5F74A3"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6075A2"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.26,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6175A2"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.21,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6275A2"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.17,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6276A1"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.12,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6376A1"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.08,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6476A1"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.03,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6477A1"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.99,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6577A0"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.94,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6677A0"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6778A0"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.85,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#67789F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.81,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#68789F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.76,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#69799F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.72,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#69799F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.67,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6A799E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.62,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6B7A9E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.58,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6B7A9E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.53,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6C7A9E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.49,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6D7B9D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.44,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6D7B9D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6E7B9D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.35,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#6F7C9C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.31,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#707C9C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.26,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#707C9C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.22,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#717D9B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.17,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#727D9B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.13,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#727D9B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.08,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#737E9B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#747E9A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#747E9A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.95,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#757F9A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#767F99"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.85,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#767F99"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.81,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#778099"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.76,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#788099"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.72,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#788098"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.67,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#798198"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.63,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7A8198"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7A8197"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.54,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7B8297"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.49,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7C8297"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.45,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7C8296"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.4,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7D8396"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.36,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7E8396"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7E8395"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.27,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#7F8495"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.22,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#808495"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.18,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#808594"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.13,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#818594"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.08,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#818594"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#828693"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.99,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#838693"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.95,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#838693"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#848792"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.86,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#858792"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#858792"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.77,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#868891"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.72,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#878891"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.68,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#878991"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.63,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#888990"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#898990"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#898A90"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8A8A8F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.45,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8B8A8F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8B8B8F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.36,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8C8B8E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.31,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8C8B8E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8D8C8E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.22,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8E8C8D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.18,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8E8D8D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.13,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#8F8D8D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#908D8C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.04,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#908E8C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#918E8C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.95,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#928E8B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.91,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#928F8B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.86,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#938F8B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.82,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#94908A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.77,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#94908A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.73,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#95908A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.68,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#969189"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.63,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#969189"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#979289"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.54,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#989288"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#989288"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.45,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#999388"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.41,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9A9387"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.36,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9A9487"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.32,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9B9486"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.27,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9B9486"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.23,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9C9586"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.18,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9D9585"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.14,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9D9685"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9E9685"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.05,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9F9684"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#9F9784"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.96,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A09784"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.91,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A19883"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.86,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A19883"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.82,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A29883"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.77,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A39982"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.73,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A39982"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.68,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A49A82"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A59A81"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.59,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A69A81"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.55,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A69B81"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A79B80"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.46,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A89C80"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.41,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A89C7F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.37,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#A99D7F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.32,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AA9D7F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.28,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AA9D7E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.23,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AB9E7E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AC9E7E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.14,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AC9F7D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.09,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AD9F7D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.05,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AEA07C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AFA07C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.96,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#AFA07C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.91,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B0A17B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.87,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B1A17B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.82,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B1A27A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B2A27A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.73,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B3A37A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.69,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B3A379"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B4A479"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.6,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B5A478"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.55,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B5A478"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.51,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B6A578"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.46,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B7A577"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.41,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B8A677"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.37,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B8A676"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.32,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#B9A776"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.28,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BAA775"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.23,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BAA875"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BBA875"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.14,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BCA974"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BCA974"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.05,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BDA973"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.01,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BEAA73"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.96,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BEAA72"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.92,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#BFAB72"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.87,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C0AB71"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.83,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C1AC71"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.78,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C1AC70"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.74,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C2AD70"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.69,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C3AD6F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.64,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C3AE6F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C4AE6E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.55,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C5AE6E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.51,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C6AF6D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.46,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C6AF6D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.42,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C7B06C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.37,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C8B06C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.33,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C8B16B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.28,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#C9B16B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.24,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CAB26A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.19,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CAB26A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.15,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CBB369"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CCB368"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.06,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CCB468"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.01,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CDB467"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.97,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CEB467"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.92,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CFB566"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.87,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#CFB566"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.83,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D0B665"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.78,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D1B665"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.74,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D1B764"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.69,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D2B763"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.65,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D3B863"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D3B862"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.56,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D4B962"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D5B961"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.47,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D6BA60"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.42,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D6BA60"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.38,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D7BB5F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.33,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D8BB5F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.29,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D8BC5E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.24,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#D9BC5E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#DABD5D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.15,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#DBBD5C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#DBBE5C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.06,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#DCBE5B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.01,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#DDBF5B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.97,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#DDBF5A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.92,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#DEC059"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.88,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#DFC059"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.83,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E0C158"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E0C158"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.74,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E1C257"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E2C257"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.65,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E3C356"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.61,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E3C355"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.56,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E4C455"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.52,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E5C454"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.47,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E5C554"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.43,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E6C553"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.38,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E7C653"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.33,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E7C652"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.29,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E8C752"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.24,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#E9C751"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#EAC850"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.15,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#EAC850"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.11,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#EBC94F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.06,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#ECC94F"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.02,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#ECCA4E"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.97,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#EDCA4D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.93,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#EECB4D"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.88,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#EFCB4C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.84,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#EFCC4C"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.79,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F0CC4B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.75,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F1CD4B"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F2CD4A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.65,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F2CE4A"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.61,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F3CF49"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.56,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F4CF49"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.52,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F5D048"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.47,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F6D148"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.43,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F7D147"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.38,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F9D247"
    },
    width: 0.05,
    height: 48.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.88,
    y: 0.25,
    style: {
      clipPath: "url(#SVGID_00000082340667182438182840000010575149260677916811_)",
      fill: "#F9D247"
    },
    width: 4.5,
    height: 48.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st390",
    d: "M25.42,49.9c-8.18-0.04-14.83-6.71-14.85-14.87l0,0c-0.01-4.98,3.06-10.65,6.31-16.66 c3.26-6.03,6.64-12.27,7.21-18.25h2.64c0.57,5.98,3.95,12.22,7.21,18.25c3.25,6.01,6.32,11.68,6.31,16.66 C40.24,43.19,33.59,49.86,25.42,49.9z M25.42,6.42c-1.46,4.47-3.86,8.89-6.2,13.22c-3.09,5.7-6,11.09-5.99,15.39l0,0 c0.01,6.71,5.49,12.19,12.2,12.22c6.7-0.03,12.17-5.51,12.18-12.22c0.01-4.3-2.91-9.69-5.99-15.39 C29.28,15.31,26.88,10.89,25.42,6.42z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClrHeaderLogo);
export default __webpack_public_path__ + "static/media/clr_header_logo.59f5b065d5dfe35b902b6446ecd4ed05.svg";
export { ForwardRef as ReactComponent };